<template>
	<div class="cdiv">
		<div class="header flex">
			<div>
				<el-image class="weiziiconst" :src="require('../assets/img/dingwei.png')" fit="cover"></el-image>
			</div>
			<div class="pleft">当前位置：<span>首页</span><span>>机票订单</span><span>>机票订单详情</span></div>
		</div>
		<div class="right">
			<div class="addpgstyle">
				订单状态：{{ baseData.status_name }}
				<span v-if="baseData.danwei_name != null && baseData.danwei_name != ''"> 所属单位：{{ baseData.danwei_name }}</span>
			</div>
			<div class="rightDetail">
                <p v-if="baseData.old_liushui_no" class="rebookNo" style="cursor: pointer" @click="forwardairticketorderdetails(baseData.old_liushui_no)">
                	{{baseData.type == 1 ? '(改签)' : (baseData.type == 2 ? '(退票)': '')}} 原流水号：{{ baseData.old_liushui_no }}
                </p>
				<span v-if="baseData.pay_status != 2 && !['4', '11'].includes(baseData.ticket_status)" class="editBtn pass" @click="addOrderPassenger">新增乘客</span>
				<span v-if="!['4', '11'].includes(baseData.ticket_status)" class="editBtn" @click="editType = !editType">{{ editType ? "取消" : "修改" }}</span>
			</div>
		</div>

		<div class="tcontent">
			<div class="ttop flex">
				<div class="liushuino graycolor">流水号：{{ baseData.liushui_no }}</div>
				<div class="xiadandate graycolor">下单时间：{{ baseData.create_time }}</div>
			</div>
			<template v-for="(item, index) in xcList">
				<div class="tcontentxc flex" :key="item.arto_id">
					<div class="scheci commonmtop">
						<div class="sccdate flex">
							<div class="startzhan">{{ item.send_city }}</div>
							<div class="iconstyles">
								<el-image style="margin-left: 1vw" class="weiziicon" :src="require('../assets/img/shi.png')" fit="cover"></el-image>
							</div>
						</div>
						<div class="scdiv flex startweight bluecolor">
							{{ formatDate(item.send_date) }}
						</div>
					</div>
					<div class="haoshi commonmtop">
						<div class="cxinfo">{{ item.flight_number }}</div>
						<div>
							<el-image class="weiziicon lineicon" :src="require('../assets/img/xian.png')" fit="cover"></el-image>
						</div>
						<div class="sleft">
							<span>起飞时间：{{ item.send_date }}</span> {{ item.flight_hours }}
						</div>
					</div>
					<div class="endcheci commonmtop">
						<div class="sccdate flex">
							<div class="startzhan">{{ item.arrival_city }}</div>
							<div class="iconstyles">
								<el-image style="margin-left: 1vw" class="weiziicon" :src="require('../assets/img/zhong.png')" fit="cover"></el-image>
							</div>
						</div>
						<div class="scdiv flex startweight bluecolor">
							{{ formatDate(item.arrival_date) }}
						</div>
					</div>
				</div>
				<div class="hengxian linemargin" v-if="index !== xcList.length - 1" :key="item.arto_id"></div>
			</template>
		</div>
        <div v-show="orderPassengerSize.length && baseData.pay_status == 1">
            <Commuter ref="commuterRef" 
                type="2"
                :liushui_no="baseData.liushui_no"
                @callback="addOrderPassengerCallback"
                :team_number="baseData.team_number"
                />
        </div>
        <!--  0  其他状态   1 改签  2 退票  3 删除 -->
		<div class="tags" v-if="!editType">
            <div class="flex" v-if="baseData.type != 2">
                <div @click="filterTicket(0)" :class="{ 'tags-item': true, choosed: ticketFilter === 0 }">全部</div>
                <div @click="filterTicket(1)" :class="{ 'tags-item': true, choosed: ticketFilter === 1 }">改签</div>
                <div @click="filterTicket(2)" :class="{ 'tags-item': true, choosed: ticketFilter === 2 }">退票</div>
                <div @click="filterTicket(3)" :class="{ 'tags-item': true, choosed: ticketFilter === 3 }">删除</div>
            </div>
            <div style="flex: 1;margin-left: auto;justify-content: flex-end;" class="flex">
                <el-form size="small" :inline="true" label-width="80px" class="formstyleyd" ref="ruleFormRef">
                    <el-form-item label="团号">
                        {{individual_traveler == '1' ? '散客': team_number}}
                        <!-- <el-radio class="all_t" v-model="individual_traveler" label="1">散客</el-radio>
                        <label for="">
                            <el-radio class="all_t" v-model="individual_traveler" label="0">
                                <el-input class="inputstyle" placeholder="请输入" v-model="team_number" clearable></el-input>
                            </el-radio>
                        </label> -->
                    </el-form-item>
                </el-form>
                <!-- <el-button size="small" style="margin-left: 5px;" @click="handleCreateTeamNumber">自动生成</el-button>
                <el-button size="small" style="height: 34px;background-color: #42b134;color: #fff;"
                    @click="handleUpdateTeamNumber">保存</el-button> -->
            </div>
		</div>
		<div class="detail-list" v-if="!editType">
			<div
				:class="
					'box ' +
					(item.order_status == '2' || item.order_status == '9' ? 'box2' : item.order_status == '3' || item.order_status == '10' ? 'box3' : '')
				"
				v-for="(item, index) in pgList"
			>
				<div class="num-box">
					<p class="num">{{ item.key }}</p>
					<p class="type" v-if="item.order_status && item.order_status != 1">{{ ticketTypeDic[item.order_status] }}</p>
				</div>
				<div class="info-box">
					<div class="info">
						<p class="name">{{ item.xinming }}</p>
						<p>{{ item.renyuan_leixing === "1" ? "成人" : "儿童" }}</p>
						<p>{{ item.card_type === "1" ? "身份证" : "护照" }}：{{ formatCardId(item) }}</p>
						<p>{{ item.reserve_xiwei }}</p>
						<p>订单号：{{ item.order_no }}</p>
                        <p v-if="item.order_status == 5">{{item.is_settlement == 1 ? '已结算': '未结算'}}</p>
					</div>
                    <div class="fare-detail">
                        <span class="fare-num">国籍：{{ item.nationality }} </span>
                        <span class="fare-num">出生日期：{{ item.birthday }} </span>
                        <span class="fare-num">有效期：{{ item.effective_date }} </span>
                        <span class="fare-num">性别：{{ item.sex }} </span>
                    </div>
					<div class="fare-detail">
						<span class="fare-num">预订：{{ item.reserve_order_money }} {{ baseData.type == 1 ? `/ ${item.charge_money}`: '' }}</span>
						<span class="fare-num">票面价格：{{ item.order_money }} </span>
						<span class="fare-num">服务费与其他费：{{ Number(item.issuancefee || 0) + Number(item.customer_else_fee) }} </span>
						<span class="fare-num">小计：{{ item.real_order_money }} </span>
						<!-- <span class="fare-num">票价：{{ item.order_money }} </span>
						<span class="fare-num" v-if="item.order_status && item.order_status === 10">退票扣费：{{ item.refundfee }} </span> -->
						<span class="fare-num" v-if="item.refundfee > 0">
						    {{baseData.pay_method == 'wx' ? '微信退还' : (baseData.pay_method == 'line_credit' ? '授信退还' : '退还')}}：{{ item.refundfee }} 
						</span>
					</div>
                    <div class="new-no">
                        <span class="fare-num" v-if="item.new_type != 0" 
                            style="cursor: pointer;"
                            @click="forwardtrainorderdetails(item.new_liushui_no)">
                            新流水号：{{ item.new_liushui_no }} </span>
                    </div>
					<!-- <p v-if="item.order_status==9">改签原因：{{item.remark_airtk}}</p>
                    <p v-if="item.order_status==10">退票原因：{{item.remark_airtk}}</p> -->
				</div>
			</div>
		</div>
        <div v-if="editType" style="flex: 1;margin-left: auto;justify-content: flex-end;padding-top: 20px;" class="flex">
            <el-form size="small" :inline="true" label-width="80px" class="formstyleyd" ref="ruleFormRef">
                <el-form-item label="团号">
                    <el-radio class="all_t" v-model="individual_traveler" label="1" @change="handleSetIndividualTraveler">散客</el-radio>
                    <label for="">
                        <el-radio class="all_t" v-model="individual_traveler" label="0">
                            <el-input :disabled="individual_traveler == '1'" class="inputstyle" placeholder="请输入" v-model="team_number" clearable></el-input>
                        </el-radio>
                    </label>
                </el-form-item>
            </el-form>
            <el-button size="small" style="margin-left: 5px;height: 34px;" @click="handleCreateTeamNumber">自动生成</el-button>
            <el-button size="small" style="height: 34px;background-color: #42b134;color: #fff;"
                @click="handleUpdateTeamNumber">保存</el-button>
        </div>
		<div class="hcorder" v-if="editType">
			<div class="flex mleftinfo">
				<el-form size="small" v-if="baseData.cancelStatus != 5" :inline="true" ref="form" :model="form" label-width="100px" class="formstyletrainord">
					<el-form-item class="fsizestyle" prop="sendcity">
						<el-checkbox class="all_t" v-model="checkAll" @change="handleCheckAllChangeSales">全选</el-checkbox>
					</el-form-item>
					<el-form-item class="fsizestyle no-align" prop="sendcity">
						<el-button v-if="baseData.pay_status == 2 && ![1, 2].includes(baseData.type)" class="sybtn" @click="gotogaiqian">改签</el-button>
						<el-button v-if="baseData.pay_status == 2 && baseData.type != 2" class="sybtn" @click="gototuipiao">退票</el-button>
						<el-button v-if="baseData.pay_status != 2" class="sybtn" @click="gotodel">删除</el-button>
					</el-form-item>
				</el-form>
			</div>
			<template
				v-for="(item, index) in pgList"
				v-if="
					!item.order_status ||
					item.order_status == 1 ||
					item.order_status == 5 ||
					item.order_status == 6 ||
					item.order_status == 7 ||
					item.order_status == 8
				"
			>
				<div :key="item.aorpg_id + 'a'" class="flex mleftinfo">
					<el-form size="small" :inline="true" ref="form" :model="form" label-width="100px" class="formstyletrainord">
						<el-form-item class="fmtop fsizestyle row-name" prop="sendcity">
							<el-checkbox class="selck" v-model="item.check" @change="changeCheck">{{ item.xinming }}</el-checkbox>
						</el-form-item>
						<el-form-item class="fmtop fsizestyle" prop="sendcity">
							<span class="cstyle">{{ item.renyuan_leixing === "1" ? "成人" : "儿童" }}</span>
							<span class="cstyle">{{ item.card_type === "1" ? "身份证" : "护照" }}：{{ formatCardId(item) }}</span>
							<!-- <span class="cstyle">{{ typeDic[item.xiwei] }} {{ item.zuowei }}</span> -->
							<span class="cstyle"> 订单号：{{ item.order_no }} </span>
						</el-form-item>
						<el-form-item class="fmtop fsizestyle" prop="sendcity">
							<span class="cstyle" v-if="item.is_buy_baoxian === '1'">
								<el-image class="imgmargin" :src="require('../assets/img/bao.png')" fit="cover"></el-image>
							</span>
							<span class="cstyle imgmargin" v-if="baseData.order_status != 5">
								<el-image class="weiziicon" @click="() => gotoupdate(item)" :src="require('../assets/img/bianji02.png')" fit="cover"></el-image>
							</span>
						</el-form-item>
					</el-form>
				</div>
				<div :key="item.aorpg_id + 'c'" class="flex mleftinfo" v-if="item.order_status && item.order_status != 1">
					<el-form size="small" :inline="true" ref="form" :model="form" label-width="100px" class="formstyletrainord" style="padding-top: 0">
						<el-form-item class="fmtop fsizestyle row-name" prop="sendcity">
							{{ ticketTypeDic[item.order_status] }}
						</el-form-item>
						<el-form-item class="fmtop fsizestyle row-name" prop="sendcity" v-if="item.order_status == 2">
							改签流水号：{{ item.liushui_no || item.changedata.liushui_no }}
						</el-form-item>
					</el-form>
				</div>
				<div :key="item.aorpg_id + 'b'" v-if="index !== pgList.length - 1" class="hengxian"></div>
			</template>
		</div>
		<div class="download flex">
            <span class="editBtn add-remark-btn" @click="addRemarkDialogVisible = true">增加备注</span>
            <span v-if="baseData.draw_ticket_status == 2" class="editBtn pass" @click="pdfData(baseData.liushui_no)">PDF信息</span>
            <span v-if="baseData.draw_ticket_status == 2" class="editBtn pass" @click="download(baseData.liushui_no)">行程信息</span>
        </div>
		<div class="remark-list">
            <div class="remark-item hearder">
                <span class="content">备注内容</span>
                <span class="date">备注时间</span>
                <span class="status">状态</span>
                <span class="btn" style="display: flex;justify-content: center">操作</span>
            </div>
            <div class="remark-item" v-for="item in remarkList" :key="item.id">
                <span class="content">{{item.content}}</span>
                <span class="date">{{item.createtime}}</span>
                <span class="status" :style="item.status == '0'? 'color: #f00;': ''">{{item.status_name}}</span>
                <span class="btn"><el-button v-show="item.status == 1" class="editBtn pass" @click="cancelRemark(item.id, baseData.liushui_no)">作废</el-button></span>
            </div>
            <div class="no-data" v-show="remarkList.length == 0">
                无备注数据
            </div>
        </div>
        <div class="ftbottom flex">
			<div class="xiadanperson">下单共{{ baseData.namecount }}人</div>
			<div>
			    预定金额：<span class="moneycolor">￥{{ baseData.order_money }}</span>
				订单金额：<span class="moneycolor">￥{{ baseData.real_order_money }}</span>
			</div>
		</div>
		<div class="obtn flex" v-if="baseData.cancelStatus !== '5' && baseData.refundStatus !== '3'">
			<div v-if="baseData.pay_status != 2 && !['4', '11'].includes(baseData.ticket_status)">
				<el-button class="cancelbtn" @click="handelCancle">取消</el-button>
			</div>
			<div v-if="baseData.pay_status != 2 && !['4', '11'].includes(baseData.ticket_status) && baseData.order_money>0">
				<el-button class="paybtn" @click="toPayOrder(baseData)">支付</el-button>
			</div>
			<div v-if="baseData.type == 1 && baseData.order_money<=0">
				<el-button class="paybtn" @click="toQuerenOrder(baseData)">确认</el-button>
			</div>
		</div>

		<div class="copyright">工业和信息化部备案管理系统网站 豫B1-20080191-28</div>
		<el-dialog
			v-show="dialogVisible"
			:visible="dialogVisible"
			width="380px"
			top="80px"
			:show-close="false"
			:before-close="handleCloseTuipiao"
			class="tpinfo"
		>
			<el-card shadow="never" class="box-card">
				<el-form ref="form" :rules="rules" :model="form" label-width="80px">
					<div>
						<div class="tptitle">退票</div>
						<div class="pgmargintop flex">
							<div class="pgmleft">确认退票吗？</div>
						</div>
					</div>
					<div class="btnstylesinfo">
						<el-button
							class="login-btn clearbtn"
							@click="closex"
							style="background-color: rgba(181, 181, 181, 1); color: #ffffff; margin-right: 20px; width: 100px"
						>
							取消
						</el-button>
						<el-button
							@click="handleTuipiao"
							class="login-btn"
							type="primary"
							style="background-color: rgba(66, 177, 52, 1); margin-left: 20px; width: 100px"
							>确认</el-button
						>
					</div>
				</el-form>
			</el-card>
		</el-dialog>
		<el-dialog title="改签" v-show="dialoggaiqianVisible" :visible="dialoggaiqianVisible" width="700px" top="80px" :before-close="handleClosegaiqian">
			<el-card shadow="never" class="box-card">
				<el-form ref="gaiqian" :rules="rules" :model="form" class="formstyleyd" label-width="100px">
					<div class="flex">
						<el-col :span="12">
							<el-form-item label="出发:" class="fsizestyle" prop="sendcity">
								<el-input class="inputstyle heightstyle" placeholder="请输入" v-model="form.sendcity" clearable></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="到达:" class="fsizestyle" prop="arrivalcity">
								<el-input class="inputstyle heightstyle" placeholder="请输入" v-model="form.arrivalcity" clearable></el-input>
							</el-form-item>
						</el-col>
					</div>
					<div class="flex">
						<el-col :span="12">
							<el-form-item label="出发日期:" prop="senddate">
								<el-date-picker
									class="inputstyle"
									type="datetime"
									placeholder="选择日期"
									format="yyyy-MM-dd HH:mm"
									value-format="yyyy-MM-dd HH:mm"
									v-model="form.senddate"
								></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="航班号:" class="fsizestyle" prop="flightNumber">
								<el-input class="inputstyle heightstyle" placeholder="请输入" v-model="form.flightNumber" clearable></el-input>
							</el-form-item>
						</el-col>
					</div>
					<div class="flex">
						<el-col :span="12">
							<el-form-item label="舱位" class="" prop="cabintype">
								<el-select class="inputstyle" v-model="form.cabintype" placeholder="选择席座">
									<el-option label="经济舱" value="经济舱"></el-option>
									<el-option label="头等舱" value="头等舱"></el-option>
									<el-option label="公务舱" value="公务舱"></el-option>
									<el-option label="商务舱" value="商务舱"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</div>
					<div class="flex">
						<el-col :span="24">
							<el-form-item label="改签原因:" class="fsizestyle" prop="remarkAirtk">
								<el-input
									type="textarea"
									show-word-limit
									resize="none"
									:rows="5"
									style="width: 100%"
									placeholder="请输入"
									v-model="form.remarkAirtk"
									clearable
								></el-input>
							</el-form-item>
						</el-col>
					</div>
					<div class="flex">
						<span class="gqdesc"> 改签说明：发只能改签15天以内的航班 </span>
					</div>
					<div class="pgbtns">
						<el-button class="login-btn confirmbtn" type="primary" @click="handleGaiqian" style="background-color: rgba(66, 177, 52, 1)"
							>提交</el-button
						>
					</div>
				</el-form>
			</el-card>
		</el-dialog>
		<el-dialog title="修改" v-show="dialogupdateVisible" :visible="dialogupdateVisible" width="50%" top="80px" :before-close="handleCloseupdate">
			<el-card shadow="never" class="box-card">
				<el-form ref="form" :rules="rules" :model="form" class="formstyleyd" label-width="80px">
					<div class="flex">
						<el-form-item label="人员类型" class="mttop" prop="sendcity">
							<el-col :span="20">
								<el-select v-model="form.rytype" placeholder="选择人员类型">
									<el-option label="成人" value="1"></el-option>
									<el-option label="儿童" value="2"></el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item label="姓名" class="mttop fsizestyle" prop="sendcity">
							<el-col :span="20">
								<el-input class="inputstyle heightstyle" placeholder="请输入" v-model="form.user" clearable></el-input>
							</el-col>
						</el-form-item>
					</div>
					<div class="flex">
						<el-form-item label="证件类型" class="mttop" prop="sendcity">
							<el-col :span="20">
								<el-select v-model="form.idtype" placeholder="选择证件类型">
									<el-option label="身份证" value="1"></el-option>
									<el-option label="护照" value="2"></el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item label="证件号码" class="fsizestyle" prop="sendcity">
							<el-col :span="20">
								<el-input class="zjinputstyle heightstyle" placeholder="请输入" v-model="form.id" clearable></el-input>
							</el-col>
						</el-form-item>
					</div>
					<div class="flex">
						<el-form-item label="购买保险" class="fsizestyle" prop="sendcity">
							<el-radio-group v-model="form.isbaoxian">
								<el-radio class="all_t" label="1">是</el-radio>
								<el-radio class="all_t" label="2">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</div>
					<div class="pgbtns">
						<el-button class="login-btn confirmbtn" @click="confirmUpdate" type="primary" style="background-color: rgba(66, 177, 52, 1)"
							>提交</el-button
						>
					</div>
				</el-form>
			</el-card>
		</el-dialog>
        <el-dialog :title="`请选择支付方式   --  金额:【${payOrder.order_money}】 `" :visible.sync="payDialogVisible" class="pay-dialog" width="550px">
          <div class="pay-box">
              <div class="pay-item" v-if="userInfoData.role_id == 0">
                  <el-image class="pay-type" :src="require('../assets/img/alipay.png')"
                            @click="handlePay(1)"
                            fit="cover"></el-image>
                    <span>支付宝支付</span>
              </div>
              <div class="pay-item" v-if="userInfoData.role_id == 0">
                  <el-image class="pay-type" :src="require('../assets/img/wxpay.png')"
                            @click="handlePay(2)"
                            fit="cover"></el-image>
                            <span>微信支付</span>
              </div>
              <div class="pay-item" v-if="[1, 2].includes(userInfoData.role_id)">
                  <el-image class="pay-type" :src="require('../assets/img/creditpay.png')"
                            @click="handlePay(3)"
                            fit="cover"></el-image>
                            <span>授信支付</span>
              </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="payDialogVisible = false">取 消</el-button>
          </div>
        </el-dialog>
        <el-dialog :title="`请扫码支付  --  金额:【${payOrder.order_money}】`" :visible.sync="wxPayDialogVisible" class="pay-dialog" width="550px">
          <div class="pay-qrcode-box">
              <div><span>订单编号：{{payOrder.liushui_no}}</span><br></div>
              <el-image class="wx-pay-qrcode" style="width: 300px; height: 300px;" :src="wxPayQrcode" fit="cover"></el-image>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button style="background: #42b134;color:#fff" @click="payDone">支付完成</el-button>
            <el-button @click="wxPayDialogVisible = false">取 消</el-button>
          </div>
        </el-dialog>
        <el-dialog title="订票信息" :visible.sync="pdfDialogVisible" width="70%" top="80px">
			<div style="overflow: hidden;">
				<span class="editBtn pass" @click="pdfDayin">PDF打印</span>
			</div>
            <div class="pdf-info" ref="pdfinfo">
                <div class="pdf-item" v-for="item in pdfInfo.orderpassenger">
                    <div class="pdf-header flex-col">
                        <span>中国民航 China Civil Aviation</span>
                        <span class="font-18 text-center">行程信息提示</span>
                        <span class="text-center">Trip Information Reminders</span>
                    </div>
                    <div class="pdf-content">
                        <span>起飞时间: {{pdfInfo.orderdata.send_date}}</span>
                        <div class="flex flex-space-between" v-for="xc in item.xingcheng">
                            <span><span class="font-18">{{xc.send_city}}</span><span class="font-12">站</span></span>
                            <span class="font-18" style="text-decoration: underline">{{xc.flight_number}}</span> 
                            <span><span class="font-18">{{xc.arrival_city}}</span><span class="font-12">站</span></span>
                        </div>
                        <div class="flex flex-space-between" style="padding: 6px 0;">
                            <span class="font-18">{{pdfInfo.orderdata.en_departure_station}}</span>
                            <span class="font-18">{{pdfInfo.orderdata.en_arrival_station}}</span>
                        </div>
                        <div class="zx">
                            <span class="font-18">{{item.cabin_type}}</span>
                        </div>
                        <div>限乘当日当次车</div>
                        <div>
                            <span>{{item.xinming}}</span>
                            <span style="margin-left: 10px;">{{item.enc_card_id}}</span>
                        </div>
                        <div class="flex flex-space-between">
                            <span>订单号：{{item.order_no}}</span>
                            <span>票价：{{item.order_money}}</span>
                        </div>
                    </div>
                    <div class="pdf-desc flex">
                        <div class="left font-12 flex-col">
                            <span>温馨提示</span>
                            <span>1.此凭条不可作为乘客凭证使用，请您持购票证件进站检票乘车。</span>
                            <span>2.为方便您在网上办理行程变更手续，建议在行程结束后按需领取报销凭证。</span>
                            <span>3.欢迎扫码查阅乘车须知，下载铁路12306APP。</span>
                        </div>
                        <div class="right" style="padding-top: 15px;">
                            <img class="pdf-qrcode" :src="pdfInfo.qr_image" />
                        </div>
                    </div>
                    <div style="padding-top: 5px;">
                        请按行程信息提示乘车，祝您旅途愉快!
                    </div>
                </div>
            </div>
        </el-dialog>
		<el-dialog
			v-show="querendialogVisible"
			:visible="querendialogVisible"
			width="380px"
			top="80px"
			:show-close="false"
			:before-close="handleCloseQueren"
			class="tpinfo"
		>
			<el-card shadow="never" class="box-card">
				<el-form ref="form" :rules="rules" :model="form" label-width="80px">
					<div>
						<div class="tptitle">确认</div>
						<div class="pgmargintop flex">
							<div class="pgmleft">确认此订单？</div>
						</div>
					</div>
					<div class="btnstylesinfo">
						<el-button
							class="login-btn clearbtn"
							@click="handleCloseQueren"
							style="background-color: rgba(181, 181, 181, 1); color: #ffffff; margin-right: 20px; width: 100px"
						>
							取消
						</el-button>
						<el-button
							@click="handleQueren"
							class="login-btn"
							type="primary"
							style="background-color: rgba(66, 177, 52, 1); margin-left: 20px; width: 100px"
							>确认</el-button
						>
					</div>
				</el-form>
			</el-card>
		</el-dialog>
        <el-dialog title="增加备注" :visible.sync="addRemarkDialogVisible" class="add-remark-dialog" width="550px">
            <div class="content">
                <span>备注内容:</span>
                <textarea v-model="remarkContent" class="content-area"></textarea>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button style="background: #42b134;color:#fff" @click="addRemark(baseData.liushui_no)">提交</el-button>
                <el-button @click="addRemarkDialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Cookie from "js-cookie";
import ElImage from "element-ui/packages/image/src/main";
import ElCard from "element-ui/packages/card/src/main";
import ElButton from "element-ui/packages/button/src/button";
import { API_BASE_URL } from '../utils/config'
import { 
    airlineticketPdfData,
    checkAirlineticket,
    airlineticketXcExport,
    delairorder,
    queryairtorderbyId,
    airlineticketInfo,
    updateairgaiqianordstatus,
    updateairorderpg,
    updateairorderstatus,
    updatetairpordstatus,
    getUserInfo,
    airPay,
    airQueren,
    airlineticketRemarkList,
    airlineticketAddRemark,
    airlineticketCancellation,
    airlineticketChangeTeamNumber,
    airlineticketGetTeamNumber
} from "@/api";
import Commuter from "./OrderCommuter.vue";
export default {
	components: {
		ElButton,
		ElCard,
		ElImage,
        Commuter
	},
	data() {
		return {
            individual_traveler: '0',
            team_number: '',
			userinfo: "",
			ischecked: false,
			dialogVisible: false,
			dialoggaiqianVisible: false,
			dialogupdateVisible: false,
			textareaValue: "",
			form: {
				isbaoxian: "2",
				isnobaoxian: false,
				zuoxi: "1",
				idtype: "1",
				id: null,
				user: null,
				rytype: "1",
				sendcity: "",
				arrivalcity: "",
				senddate: "",
				cabintype: "",
				remarkAirtk: "",
				flightNumber: "",
			},
			checkAll: false,
			rules: {
				mobilephone: [
					{ required: true, message: "请输入手机号", trigger: "blur" },
					{ pattern: /^1[3-9]\d{9}$/, message: "手机号格式不正确", trigger: "blur" },
				],

				pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
				sendcity: [{ required: true, message: "请输入出发地点", trigger: "blur" }],
				arrivalcity: [{ required: true, message: "请输入到达地点", trigger: "blur" }],
				senddate: [{ required: true, message: "请输入出发日期", trigger: "blur" }],
				flightNumber: [{ required: true, message: "请输入航班号", trigger: "blur" }],
				cabintype: [{ required: true, message: "请输入舱位", trigger: "blur" }],
				remarkAirtk: [{ required: true, message: "请输入改签原因", trigger: "blur" }],
			},
            drawTicketStatus: {
                0: '未出票',
                1: '出票中',
                2: '已完成'
            },            
            payStatus: {
                1: '待付款',
                2: '已付款'
                //: '付款中',
            },
			ticketTypeDic: {
				1: "待付款",
				2: "改签审核中",
				3: "退票审核中",
				4: "取消审核中",
				5: "已出票",
				6: "改签拒绝",
				7: "退票拒绝",
				8: "取消拒绝",
				9: "已改签",
				10: "已退票",
				11: "已取消",
                12: "已删除",
                13: "退票中",
                14: "未出票已退票",
                15: "改签中"
			},
			// 票类型筛选
			ticketFilter: 0,
			//票列表
			passengerList: [],
			baseData: {},
			xcList: [],
			pgList: [],
			updateId: "",
			upateLiushui: "",
			editType: false,            
            payOrder: {},
            payDialogVisible: false,
            userInfoData: {},
            addOrderPassengerType: false,
            orderPassengerSize: [],
            wxPayDialogVisible: false,
            wxPayQrcode: '',
            pdfDialogVisible: false,
            pdfInfo: {
                orderdata: {},
                orderpassenger: []
            },
			querendialogVisible:false,
            remarkList: [],
            addRemarkDialogVisible: false,
            remarkContent: ''
		};
	},
	created() {
		this.userinfo = JSON.parse(Cookie.get("userinfo"));
		this.ischecked = true;
	},
	activated() {
        this.editType = false;
		this.getDetail();        
        const userinfo = JSON.parse(Cookie.get("userinfo"));
        this.userinfo = userinfo;
        this.orderPassengerSize = this.$refs.commuterRef.ruleForm.passengersList;
        getUserInfo({user_id: userinfo.id}).then(res => {
            const resData = res.data;
            if(resData.code == 1) {
                this.userInfoData = resData.data
            }
        })
        this.ticketFilter = 0;
	},
    watch: {
    	$route() {
    		this.getDetail();
    	},
    },
	methods: {
        handleSetIndividualTraveler(e) {
            if(e == '1') {
                //this.team_number = '';
            }
        },
        handleCreateTeamNumber() {
            this.individual_traveler = '0';
            airlineticketGetTeamNumber({}).then(res => {//train_number
                this.team_number = res.data.data;
            })
        },
        handleUpdateTeamNumber() {
            airlineticketChangeTeamNumber({
                "liushui_no": this.baseData.liushui_no, //流水号
                "team_number": this.team_number,
                individual_traveler: this.individual_traveler
            }).then(res => {
                this.$message.success(res.data.msg);
            })
        },
        cancelRemark(id, liushui_no) {
            const ths = this;
            const user_id = this.userinfo.id
            this.$confirm("您确定要作废该记录?", "提示", {
            	confirmButtonText: "确定",
            	cancelButtonText: "取消",
            	type: "warning",
            })
            .then(async () => {
                airlineticketCancellation({
                    id,
                    user_id
                }).then(res => {
                    if(res.data.code == 1) {
                        ths.$message.success('操作成功');
                        ths.reloadRemarkList(liushui_no);
                    }
                    else {
                        ths.$message.warning(res.data.msg);
                    }
                })
            })
            .catch(() => {});
        },
        addRemark(liushui_no) {
            const ths = this;
            const content = ths.remarkContent;
            if(!content) {
                ths.$message.warning('请输入备注内容');
                return;
            }
            const user_id = ths.userinfo.id;
            airlineticketAddRemark({
                liushui_no,
                content,
                user_id
            }).then(res => {
                if(res.data.code == 1) {
                    ths.remarkContent = '';
                    ths.addRemarkDialogVisible = false;
                    ths.$message.success(res.data.msg);
                    ths.reloadRemarkList(liushui_no);
                }
                else {
                    ths.$message.warning(res.data.msg);
                }
            })
        },
        pdfData(liushui_no) {
            const ths = this;
            airlineticketPdfData({
                liushui_no
            }).then((res) => {
                if(res.data.code == 1) {
                    ths.pdfInfo = res.data.data;
                    ths.pdfDialogVisible = true;
                }
                else {
                    ths.$message.warning(res.data.msg);
                }
            });
        },
		pdfDayin(){
			const printContents = this.$refs.pdfinfo.outerHTML;  // 获取要打印的区域
			// 创建一个新的窗口
			const printWindow = window.open('', '', 'height=600,width=800');
			printWindow.document.write('<html><head><title>打印</title>');
			printWindow.document.write('<style>.pdf-info {display: flex;column-gap: 10px;padding-bottom: 30px;color: #444;flex-wrap: wrap;}.pdf-info .font-18 {font-size: 18px;}.pdf-info .font-12 {font-size: 12px;}.pdf-info .flex {display: flex;}.pdf-info .flex-col {display: flex;flex-direction: column;}.pdf-info .flex-space-between {justify-content: space-between;}.pdf-info .text-center {text-align: center;}.pdf-info .pdf-item {border: 1px solid #777;width: 300px;min-width: 300px;max-width: 300px;padding: 30px 10px 80px;}.pdf-info .pdf-header {border-bottom: 1px dashed #777;row-gap: 6px;}.pdf-info .pdf-content {border-bottom: 1px dashed #777;line-height: 25px;}.pdf-info .pdf-desc {column-gap: 10px;}.pdf-info .pdf-qrcode {width: 130px;height: 130px;}</style>');  // 可以自定义样式
			printWindow.document.write('</head><body>');
			printWindow.document.write(printContents);  // 写入要打印的内容
			printWindow.document.write('</body></html>');
			printWindow.print();  // 调用打印
			printWindow.close();  // 关闭文档流
		},
        download(liushui_no) {
            const _this = this;
            airlineticketXcExport({
                liushui_no
            }).then((res) => {
                if(res.data.code == 1)
                    window.open(res.data.data.url, "_blank");
                else 
                    _this.$message.warning(res.data.msg);
            })
        },
        payDone() {
            const _this = this;
            airlineticketInfo(_this.payOrder.liushui_no).then(res => {
                if(res.data.code == 0) {
                    _this.$message.warning(res.data.msg);
                }
                else if(res.data.code == 1) {                    
                    _this.wxPayDialogVisible = false;  
                    _this.payOrder = {};
                    _this.getDetail();
                }
                if(res.data.data.pay_status == 2) {
                    _this.$message.success('支付成功');
                }
            })
        },
        addOrderPassengerCallback() {
            this.$refs.commuterRef.ruleForm.passengersList = [];
            this.getDetail();
        },
        addOrderPassenger() {
            this.$refs.commuterRef.addPassenger();
        },
        handlePay(type) {
            const _this = this;
            //ali 支付宝  wx 微信 line_credit 授信额度
            const payMethod = (type == 3 ? 'line_credit': (type == 1 ? 'ali': (type == 2 ? 'wx': null)))
            if(!payMethod) return;
            if(type == 1) {
                const url = `${API_BASE_URL}/api/airlineticket/air_pay?pay_method=ali&user_id=${_this.userinfo.id}&liushui_no=${_this.payOrder.liushui_no}`;
                window.open(url, '_self');
            }
            else {
                airPay({
                    "user_id": _this.userinfo.id, //用户id
                    "pay_method": payMethod, //wx 微信 ali 支付宝  line_credit 授信额度
                    "liushui_no": _this.payOrder.liushui_no //订单流水号
                }).then(res => {
                    if(type == 3) {
                        if(res.data.code == 1) {
                            _this.payDialogVisible = false;
                            _this.payOrder = {};
                            _this.getDetail();
                        }
                        _this.$message.warning(res.data.msg);
                    }
                    else if(type == 2) {
                        if(res.data.code == 1) {
                            _this.payDialogVisible = false;
                            _this.wxPayDialogVisible = true;
                            _this.wxPayQrcode = res.data.data.image_url;
                        }
                    }
                })
            }
        },
        toPayOrder(order) {
            this.payOrder = order;
            this.payDialogVisible = true;
        },
		// 确认窗口
		toQuerenOrder(){
			this.querendialogVisible = true;
		},
		// 关闭确认窗口
		handleCloseQueren() {
			this.querendialogVisible = false;
		},
		handleQueren(){
			const _this = this;
			airQueren({
				"user_id": _this.userinfo.id, //用户id
				"liushui_no": _this.baseData.liushui_no //订单流水号
			}).then(res => {
				if(res.data.code == 1) {
					_this.querendialogVisible = false;
					_this.getDetailId();
				}
				_this.$message.warning(res.data.msg);
			})
		},
        formatCardId(info) {
            let cardId = info.card_id;
            return info.card_type === "1" ? 
                (cardId.substring(0, 8) + '******' + cardId.substring(cardId.length - 4))
                    :cardId.substring(0, cardId.length - 2) + '**';
        },
        forwardairticketorderdetails(orderId) {
        	this.$router.push("/airticketorderdetails?id=" + orderId);
        },
		// 输入 YYYY-MM-DD HH:mm:ss 输出  HH:mm
		formatDate(date) {
			if (date) {
				return date.slice(11, 16);
			}
		},
		async getDetail() {
			try {
				const id = this.$route.query.id;
				const data = await queryairtorderbyId({
					user_id: this.userinfo.id,
					liushui_no: id,
				});
				//console.log("%c Line:517 🍎 data", "color:#33a5ff", data.data.data);
				if (data.data.code == 1) {
					this.baseData = data.data.data;
                    this.team_number = data.data.data.team_number;
                    this.individual_traveler = data.data.data.individual_traveler + '';
					this.xcList = this.baseData.xingcheng;
					this.pgList = this.baseData.passenger.map((item) => {
						item["check"] = false;
						return item;
					});
					this.passengerList = this.pgList;
					this.$forceUpdate();
				}
                this.reloadRemarkList(id);
			} catch (error) {
				this.baseData = {};
			}
		},
        reloadRemarkList(liushui_no) {
            const ths = this;
            airlineticketRemarkList({
                liushui_no
            }).then(res => {
                ths.remarkList = res.data.data.list;
            })
        },
		handleCheckAllChangeSales(val) {
			this.pgList.forEach((item) => {
				if (val) {
					// if (!item.order_status || item.order_status == 1 || item.order_status == 6 || item.order_status == 7 || item.order_status == 8) {
					// 	item.check = true;
					// }
                    item.check = true;
				} else {
					item.check = false;
				}
			});
		},
		changeCheck() {
			// 判断  list  中 的  item  的  check  是 全部选中还是部分选中 还是 全不选中
			let flag = true;
			this.pgList.forEach((item) => {
				if (item.order_status == 1 || item.order_status == 5 || item.order_status == 6 || item.order_status == 7 || item.order_status == 8) {
					if (!item.check) {
						flag = false;
					}
				}
			});
			this.checkAll = flag;

			this.$forceUpdate();
		},
		closex() {
			this.dialogVisible = false;
		},
		//删除
		gotodel() {
			if (this.pgList.every((item) => !item.check)) {
				this.$message({
					type: "warning",
					message: "请选择删除乘客",
				});
				return;
			}
			this.$confirm("您确定要删除该记录?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(async () => {
					const ids = this.pgList
						.filter((item) => item.check)
						.map((item) => {
							return item.aorpg_id;
						})
						.join(",");
					try {
						const id = this.$route.query.id;
						const userinfo = JSON.parse(Cookie.get("userinfo"));
						const data = await delairorder({
							liushui_no: id,
							topg_ids: ids,
							user_id: userinfo.id,
						});
						if (data.data.code != 1) {
							this.$message({
								type: "error",
								message: data.data.msg,
							});
						} else {
							this.$message.success("删除成功");
							this.getDetail();
						}
					} catch (error) {
						this.$message.error("删除失败");
					}
				})
				.catch(() => {
					//     this.$message({
					//     type: 'info',
					//     message: '已取消删除'
					// });
				});
		},
		//退票关闭窗口
		handleCloseTuipiao() {
			this.dialogVisible = false;
		},
		//退票
		gototuipiao() {
			if (this.pgList.every((item) => !item.check)) {
				this.$message({
					type: "warning",
					message: "请选择退票乘客",
				});
				return;
			}
			this.dialogVisible = true;
		},
		handleClosegaiqian() {
			this.dialoggaiqianVisible = false;
		},
		//改签弹窗
		gotogaiqian() {
			if (this.pgList.every((item) => !item.check)) {
				this.$message({
					type: "warning",
					message: "请选择改签乘客",
				});
				return;
			}
			const topg_id = this.pgList
				.filter((item) => item.check)
				.map((item) => {
					return item.aorpg_id;
				});
                
            const ths = this;
            checkAirlineticket({
                aorpg_ids: String(topg_id)
            }).then(res => {
                if(res.data.code == 0) {
                    ths.$message.warning(res.data.msg);
                }
                else {
                    const id = this.$route.query.id;
                    this.$router.push({
                        path: "/airticketgaiqian",
                        query: {
                            ids: String(topg_id),
                            orderId: id,
                        },
                    });
                    return false;
                    this.dialoggaiqianVisible = true;
                }
            })
		},
		//修改弹窗
		gotoupdate(item) {
			this.updateId = item.aorpg_id;
			this.upateLiushui = item.liushui_no;
			this.form.user = item.xinming;
			this.form.rytype = item.renyuan_leixing;
			this.form.idtype = item.card_type;
			this.form.id = item.card_id;
			this.form.isbaoxian = item.is_buy_baoxian;
			// this.form.zuoxi = item.xiwei
			this.dialogupdateVisible = true;
		},
		async confirmUpdate() {
			const { user, rytype, idtype, id, isbaoxian } = this.form;
			if (!user || !rytype || !idtype || !id) {
				this.$message({
					type: "warning",
					message: "请填写完整信息",
				});
				return;
			}

			const userinfo = JSON.parse(Cookie.get("userinfo"));
			const data = await updateairorderpg({
				user_id: userinfo.id,
				aorpgId: this.updateId,
				liushuino: this.upateLiushui,
				xinming: user,
				renyuanLeixing: rytype,
				cardType: idtype,
				cardId: id,
				isbuybaoxian: isbaoxian,
			});
			if (data.data.code !== 1) {
				this.$message({
					type: "error",
					message: data.data.msg,
				});
			} else {
				this.$message({
					type: "success",
					message: data.data.msg,
				});
				this.dialogupdateVisible = false;
				this.getDetail();
			}
		},
		async handleGaiqian() {
			this.$refs["gaiqian"].validate((val) => {
				if (val) {
					const aorpg_id = this.baseData.passenger
						.filter((item) => item.check)
						.map((item) => {
							return item.aorpg_id;
						});
					var form = {
						liushui_no: this.baseData.liushui_no,
						user_id: this.userinfo.id,
						aorpg_ids: String(aorpg_id),
						send_city: this.form.sendcity,
						arrival_city: this.form.arrivalcity,
						send_date: this.form.senddate,
						flight_number: this.form.flightNumber,
						cabin_type: this.form.cabintype,
						remark_airtk: this.form.remarkAirtk,
					};
					try {
						updateairgaiqianordstatus(form).then((data) => {
							if (data.data.code != 1) {
								this.$message({
									type: "error",
									message: data.data.message,
								});
							} else {
								this.$message.success("改签成功");
								//this.dialoggaiqianVisible = false;
								//this.getDetail();
                                location.reload();
							}
						});
					} catch (error) {
						this.$message.error("改签失败");
					}
				} else {
					return false;
				}
			});
		},
		async handleTuipiao() {
            const ths = this;
			const ids = this.pgList
				.filter((item) => item.check)
				.map((item) => {
					return item.aorpg_id;
				})
				.join(",");
			try {
				const id = this.$route.query.id;
				const userinfo = JSON.parse(Cookie.get("userinfo"));
				const data = await updatetairpordstatus({
					liushui_no: id,
					aorpg_id: ids,
					user_id: userinfo.id,
				});
				if (data.data.code != 1) {
					this.$message({
						type: "error",
						message: data.data.message,
					});
				} else {
					this.$message.success("退票成功");
					//this.dialogVisible = false;
					//this.getDetail();
                    location.reload();
				}
			} catch (error) {
				this.$message.error("退票失败");
			}
		},
		async handelCancle() {
			this.$confirm("是否确认取消订单?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(async () => {
					const userinfo = JSON.parse(Cookie.get("userinfo"));
					const data = await updateairorderstatus({
						liushui_no: this.baseData.liushui_no,
						user_id: userinfo.id,
					});
					if (data.data.code == 1) {
						this.$message({
							type: "success",
							message: data.data.msg,
						});
						this.$router.push({
							path: "/airticketorder",
						});
					} else {
						this.$message({
							type: "error",
							message: data.data.msg,
						});
					}

					// const data = await updateairorderstatus({
					//     aOrderId: this.baseData.aOrderId,
					//     cancelStatus: 5,
					// });
					// if (data.data.code === 200) {
					//     this.$message({
					//         type: "success",
					//         message: "操作成功!",
					//     });
					//     this.$router.push({
					//         path: "/airticketorder",
					//     })
					// }
				})
				.catch(() => {});
		},
		//转向预定申请
		forwardyuding() {
			this.$router.push("/airticketorder");
		},

		handleCloseupdate() {
			this.dialogupdateVisible = false;
		},
		//筛选票
		filterTicket(index) {
			this.ticketFilter = index;
			if (index === 0) {
				this.pgList = this.passengerList;
			} else {
				this.pgList = this.passengerList.filter((item) => {
					return item.search_ticket_status === index;
				});
			}
            console.log(index, this.pgList)
		},
	},
	name: "airticketorderdetails-right",
};
</script>

<style scoped>
    .remark-list {
        padding: 10px 0;
        font-size: 14px;
    }
    .remark-list .hearder {
        color: #777;
    }
    .remark-list .no-data {
        padding: 20px 0;
        display: flex;
        justify-content: center;
        color: #999;
    }
    .remark-list .remark-item {
        display: flex;
        border-bottom: 1px dashed #ccc;
        align-items: center;
        padding: 10px 0;
    }
    .remark-list .remark-item .content {
        flex: 1;
    }
    .remark-list .remark-item .date {
        width: 200px;
    }
    .remark-list .remark-item .status {
        width: 100px;
    }
    .remark-list .remark-item .btn {
        width: 60px;
        text-align: center;
    }
    .download .add-remark-btn {
        margin-left: 0;
        margin-right: auto;
    }
    .add-remark-dialog .content {
        display: flex;
        flex-direction: column;
    }
    .add-remark-dialog .content-area {
        resize: none;
        height: 150px;
        padding: 5px 10px;
    }
    .new-no {
        padding-top: 10px;
    }
    .pdf-info {
        display: flex;
        overflow-x: auto;
        column-gap: 10px;
        padding-bottom: 30px;
        color: #444;
    }
    .pdf-info .font-18 {
        font-size: 18px;
    }
    .pdf-info .font-12 {
        font-size: 12px;
    }
    .pdf-info .flex {
        display: flex;
    }
    .pdf-info .flex-col {
        display: flex;
        flex-direction: column;
    }
    .pdf-info .flex-space-between {
        justify-content: space-between;
    }
    .pdf-info .text-center {
        text-align: center;
    }
    .pdf-info .pdf-item {
        border: 1px solid #777;
        width: 300px;
        min-width: 300px;
        max-width: 300px;
        padding: 30px 10px 80px;
    }
    .pdf-info .pdf-header {
        border-bottom: 1px dashed #777;
        row-gap: 6px;
    }
    .pdf-info .pdf-content {
        border-bottom: 1px dashed #777;
        line-height: 25px;
    }
    .pdf-info .pdf-desc {
        column-gap: 10px;
    }
    .pdf-info .pdf-qrcode {
        width: 130px;
        height: 130px;
    }
    .pay-qrcode-box {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .pay-dialog .pay-box {
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 30px;
        padding: 20px;
    }
    .pay-dialog .pay-box .pay-item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-weight: bold;
    }
    .pay-dialog .pay-box .pay-type {
        width: 100px;
        cursor: pointer;
    }
    .pay-dialog .pay-box .pay-item:hover {
        opacity: .7;
        color: #1e9a30;
    }
.linemargin {
	margin-top: 30px;
	margin-bottom: 30px;
}

.tptitle {
	justify-content: center;
	display: flex;
	font-size: 18px;
}

.tpinfo /deep/ .el-dialog {
	-webkit-border-radius: 20px;
	-moz-border-radius: 20px;
	border-radius: 20px;
}

.tpinfo /deep/ .el-card {
	border: 1px solid #ffffff;
	-webkit-border-radius: 20px;
	-moz-border-radius: 20px;
	border-radius: 20px;
}

.tpinfo /deep/ .el-card__body {
	-webkit-border-radius: 20px;
	-moz-border-radius: 20px;
	border-radius: 20px;
}

.tpinfo /deep/ .el-dialog__body {
	padding: 0;
	color: #606266;
	font-size: 14px;
	/*word-break: break-all;*/
}

.lineicon {
	font-size: 1px;
}

.pgmleft {
	text-align: center;
}

.pgmargintop {
	margin-top: 20px;
	justify-content: center;
	display: flex;
}

.btnstylesinfo {
	margin-top: 30px;
	justify-content: center;
	display: flex;
	text-align: center;
}

.gqdesc {
	margin-left: 68px;
}

.formstyleyd .inputstyle {
	width: auto;
}

.confirmbtn {
	width: calc(48% - 0px - 10px) !important;
	padding-left: 100px;
	padding-right: 100px;
	-webkit-border-radius: 10px;
	-moz-border-radius: 10px;
	border-radius: 10px;
}

.pgbtns {
	margin-top: 20px;
	width: calc(100% - 0px - 0px) !important;
	justify-content: center;
	text-align: center;
}

.pgtop {
	margin-top: 10px;
}

.pgleft {
	margin-left: 10px;
}

.fmtop {
}

.weiziiconst {
	width: 24px;
	height: 20px;
}

.cdiv {
}

.obtn {
	margin-top: 5vh;
	margin-left: 18vw;
}

.cancelbtn {
	background: #969696;
	padding-left: 20px;
	padding-right: 20px;
	color: #ffffff;
	width: 230px;
	border-radius: 10px;
}

.paybtn {
	background: #42b134;
	padding-left: 20px;
	padding-right: 20px;
	color: #ffffff;
	width: 230px;
	margin-left: 2vw;
	border-radius: 10px;
}
.download {
    margin-top: 10px;
}
.download .btn {
    cursor: pointer;
}
.ftbottom {
	margin-top: 2vh;
    justify-content: space-between;
}

.moneycolor {
	color: #ff7342;
}

.mleftinfo .row-name /deep/ .el-checkbox__label {
	font-size: 16px;
	color: black;
}

.hengxian {
	width: calc(100% - 0px - 10px) !important;
	border: 1px dashed #999999;
	margin-bottom: 18px;
}

.imgmargin {
}

.selck {
}

.cstyle {
	margin-left: 1.5vw;
}

.cstyle .weiziicon {
	width: auto;
}

.mleftinfo {
	margin-left: 1vw;
}

.graycolor {
	color: #646464;
}

.ttop {
	margin-left: 2vw;
}

.xiadandate {
	margin-left: 8vw;
}

.fachedate {
	margin-left: 8vw;
}

.shuoming {
	font-size: 13px;
	color: #444444;
	line-height: 25px;
}

.textarea-box {
	width: 68vw;
	background-color: #f1f1f1;
	margin-top: 2vh;
	border-radius: 10px;
}

.remark {
	font-weight: bolder;
}

.orderbtn {
	width: 200px;
	height: 35px;
	border: 1px solid #42b134;
	color: #ffffff;
	padding: 10px;
	margin-top: 5vh;
	background-color: #42b134;
}

.pgbtn {
	width: 200px;
	height: 35px;
	border: 1px solid #000000;
	color: #000000;
	padding: 10px;
	margin-top: 5vh;
}

.addpg {
	margin-left: 25vw;
	margin-right: 25vw;
}

.xuhao {
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background-color: #000000;
	color: #ffffff;
	text-align: center;
}

.pginfotitle {
	width: 61vw;
	font-weight: bolder;
	margin-left: 1vw;
}

.pginfo {
	margin-top: 2vh;
}

.sfsbbtn {
	border: 1px solid #000000;
	color: #000000;
	margin-left: 1vw;
	margin-top: 4vh;
}

.btnoper {
}

.bluecolor {
	color: #42b134;
}

.startweight {
	font-weight: bolder;
	font-size: 20px;
}

.iconstyles {
}

.right {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.rightDetail {
	display: flex;
	align-items: center;
}

.rebookNo {
	margin-right: 30px;
}

.addpgstyle {
	font-weight: bolder;
}

.editBtn {
	margin-left: 20px;
	line-height: 30px;
	height: 30px;
	font-size: 14px;
	padding: 0 30px;
	border-radius: 4px;
	color: #fff;
	background: #42b134;
	float: right;
	display: inline-block;
	font-weight: normal;
	cursor: pointer;
}
.pass {
	padding: 0 10px;
}
.addpgstyle .btn {
	line-height: 30px;
	font-size: 14px;
	padding: 0 30px;
	border-radius: 4px;
	color: #fff;
	background: #42b134;
	float: right;
	display: inline-block;
	font-weight: normal;
	cursor: pointer;
}

.copyright {
	font-size: 12px;
	text-align: center;
	margin-top: 5vh;
	color: #b6b6b6;
}

.mleftmargin {
	margin-left: 1vw;
}

.pager {
	margin-top: 5vh;
	margin-left: 10vw;
}

.shouye {
}

.sybtn {
	width: 100px;
	height: 35px;
	border: 1px solid #666666;
	text-align: center;
}

.btnnodiv {
	margin-left: 1vw;
}

.btnno {
	width: 50px;
	height: 35px;
	border: 1px solid #666666;
	text-align: center;
}

.commonmtop {
	margin-top: 2vh;
}

.btnmargin {
	margin-top: 1vh;
}

.btnstyle {
	width: 100px;
	height: 35px;
	background-color: #42b134;
	color: #ffffff;
	border-radius: 5px;
}

.operbtn {
	margin-left: 8vw;
}

.checizuowei {
	margin-left: 5vw;
}

.colorstyle {
	color: #f49200;
	font-weight: bolder;
}

.checileixing {
	margin-left: 5vw;
}

.checimoney {
	margin-left: 5vw;
}

.zwleixing {
	margin-top: 0.1vh;
}

.cmtopzw {
	margin-top: 2vh;
}

.cxinfo {
	/* margin-left:12vw; */
	text-align: center;
}

.endcheci {
	/* margin-left:3vw; */
}

.sleft {
	/* margin-left:4vw; */
	text-align: center;
}

.scheci {
	/* margin-left:2vw; */
}

.startzhan {
	margin-left: 0.5vw;
}

.scdiv {
	margin-top: 2vh;
	margin-left: 1vw;
}

.sccdate {
	font-size: 20px;
	font-weight: bolder;
}

.haoshi {
	/* margin-left:3vw; */
	flex: 1;
	margin: 0 30px;
}

.tcontent {
	background-color: #f1f1f1;
	/*height:340px;*/
	margin-top: 2vh;
	-webkit-border-radius: 10px;
	-moz-border-radius: 10px;
	border-radius: 10px;
	padding-top: 4vh;
	padding-bottom: 20px;
}

.mleftd {
	margin-left: -2vw;
}

.querybtn {
	background-color: #42b134;
	color: #ffffff;
	border-radius: 5px;
	margin-left: -1vw;
}

.formstyletrainord {
	width: 100%;
	display: flex;
	padding: 0 20px;
	box-sizing: border-box;
	align-items: center;
	padding-top: 2.2vh;
}

.no-align /deep/ .el-form-item__content {
	justify-content: start !important;
}

.formstyletrainord /deep/ .el-form-item .el-form-item__content {
	/* flex: 1; */
	display: flex;
	/* justify-content: center; */
	align-items: center;
}

.formstyletrainord /deep/ .el-form-item:nth-child(2) {
	flex: 1;
}

.container {
}

.header {
	font-size: 12px;
}

.flex {
	display: flex;
}

.weiziicon {
	width: 100%;
	font-size: 0;
}

.iconstyles .weiziicon {
	width: auto;
}

.pleft {
	margin-left: 0.5vw;
	font-family: MicrosoftYaHei;
	font-weight: 400;
	font-size: 16px;
	color: #000000;
}

.hcorder {
	background-color: #f1f1f1;
	-webkit-border-radius: 10px;
	-moz-border-radius: 10px;
	border-radius: 10px;
	/*height: 250px;*/
	margin-top: 2vh;
}

.hc {
	background-color: #f1f1f1;
	width: 68vw;
	height: 14vh;
	margin-top: 2vh;
}

.hcpg {
	background-color: #f1f1f1;
	width: 68vw;
	height: 27vh;
	margin-top: 2vh;
}

button:hover {
	background-color: #42b134;
	color: #ffffff;
}

.tcontentxc {
	background-color: #f1f1f1;
	/* height:100px; */
	margin-top: 2vh;
	/* width: calc(88% - 0px - 10px) !important; */
	-webkit-border-radius: 10px;
	-moz-border-radius: 10px;
	border-radius: 10px;
	justify-content: center;
	display: flex;
	align-items: center;
	padding: 0 30px;
	box-sizing: border-box;
}

.tags {
	margin-top: 10px;
	display: flex;
}
.tags-item {
	margin-right: 10px;
	line-height: 20px;
	height: 20px;
	font-size: 14px;
	padding: 2px 10px;
	border-radius: 4px;
	font-weight: normal;
	cursor: pointer;
	background: #f1f1f1;
	color: #444444;
}
.tags ::v-deep .el-form-item {
    margin-bottom: 0;
}
.choosed {
	color: #fff;
	background: #42b134;
}

.detail-list .box {
	display: flex;
	background: #f1f1f1;
	border-radius: 10px;
	margin-top: 10px;
	align-items: center;
	padding: 20px 0;
	min-height: 90px;
	box-sizing: border-box;
}
.detail-list .box2 {
	background: #fbfbe3;
}
.detail-list .box3 {
	background: #fae5e2;
}
.detail-list .box .num-box {
	text-align: center;
	width: 120px;
}
.detail-list .box .num-box .num {
	width: 30px;
	line-height: 30px;
	border-radius: 50%;
	background: #000;
	color: #fff;
	display: inline-block;
	margin: auto;
}
.detail-list .box .num-box .type {
	font-size: 20px;
	margin: 5px 0 0;
}
.detail-list .box .info-box {
	margin-left: 20px;
}
.detail-list .fare-detail {
	margin-top: 15px;
}

.detail-list .fare-detail .fare-num {
	margin-right: 18px;
	font-size: 14px;
}
.detail-list .box .info-box .info {
	display: flex;
	align-items: flex-end;
}
.detail-list .box .info-box p {
	margin: 0;
	margin-top: 10px;
}
.detail-list .box .info-box .info p {
	margin: 0;
	margin-right: 15px;
}
.detail-list .box .info-box .info .name {
	font-size: 20px;
	font-weight: bold;
}
</style>
